;
/* SiquiRide Weather Renderer v1.0
 * Consumes siquiride-weather.json v1.0
 * Writes into #siquiride-weather
 */
(function () {
  const container = document.getElementById("siquiride-weather");
  if (!container) return;

  const url =
    container.getAttribute("data-json-url") ||
    "./siquiride-weather.json";

  const fallbackUrl =
    container.getAttribute("data-fallback-url") ||
    "./weather-fallback.json";

  function renderStatus(meta, fallbackMeta) {
    let status =
      '<div class="sqr-verified">' +
      "✓ Forecast updated: " +
      (meta.retrieval_timestamp
        ? meta.retrieval_timestamp.substring(0, 10)
        : "unavailable") +
      " | Forecast period: " +
      (meta.forecast_period_start || "unavailable") +
      " – " +
      (meta.forecast_period_end || "unavailable") +
      " | Source: PAGASA" +
      "</div>";

    if (fallbackMeta && fallbackMeta.applied_at) {
      status +=
        '<div class="sqr-stale">' +
        "<strong>Stale / Fallback:</strong> Last known good " +
        (fallbackMeta.last_good_retrieval || "unavailable") +
        ". Reason: " +
        (fallbackMeta.reason || "unknown") +
        "</div>";
    }

    return status;
  }

  function renderDay(src, interp) {
    const condition = src.condition || "unavailable";

    const temperature =
      src.temperature !== null &&
      src.temperature !== undefined
        ? src.temperature + "°C"
        : "unavailable";

    const rainfall =
      src.rainfall !== null &&
      src.rainfall !== undefined &&
      src.rainfall !== "unavailable"
        ? src.rainfall
        : "unavailable";

    const wind = src.wind || "unavailable";

    const thunderstormWatch =
      src.thunderstorm_watch === true
        ? "<strong>⚠️ Thunderstorm watch</strong>"
        : "";

    return (
      "<tr>" +
        "<td><strong>" +
        (src.date || "unavailable") +
        "</strong></td>" +

        "<td>" +
        condition +
        (thunderstormWatch
          ? "<br>" + thunderstormWatch
          : "") +
        "</td>" +

        "<td>" +
        temperature +
        " / rain: " +
        rainfall +
        " / wind: " +
        wind +
        "</td>" +

        "<td>" +
        "<strong>" +
        (interp.rating || "—") +
        "</strong> " +
        (interp.travel_advice || "unavailable") +
        "<br><em>" +
        (interp.recommended_activity_type || "") +
        "</em> — " +
        (interp.caution || "") +
        "<br><small>Confidence: " +
        (interp.confidence || "unknown") +
        "</small>" +
        "</td>" +

      "</tr>"
    );
  }

  function build(data) {
    let html =
      '<section id="siquiride-weather-output" ' +
      'aria-label="Siquijor Weather Forecast">' +

      "<h2>📊 7-Day Siquijor Weather Outlook</h2>";

    html += renderStatus(
      data.meta || {},
      data.fallback_metadata || null
    );

    html +=
      "<table>" +
        "<thead>" +
          "<tr>" +
            "<th>Date</th>" +
            "<th>PAGASA Forecast</th>" +
            "<th>Weather Details</th>" +
            "<th>SiquiRide Interpretation</th>" +
          "</tr>" +
        "</thead>" +
        "<tbody>";

    const sourceData = Array.isArray(data.source_data)
      ? data.source_data
      : [];

    const interpretation = Array.isArray(
      data.siquiride_interpretation
    )
      ? data.siquiride_interpretation
      : [];

    const rowCount = Math.max(
      sourceData.length,
      interpretation.length
    );

    for (let i = 0; i < rowCount; i++) {
      html += renderDay(
        sourceData[i] || {},
        interpretation[i] || {}
      );
    }

    html +=
        "</tbody>" +
      "</table>" +

      '<div class="disclaimer">' +
        "<strong>Source:</strong> " +
        "PAGASA Visayas Regional Forecast + Weekly Outlook. " +
        "<strong>Interpretation:</strong> " +
        "SiquiRide travel-planning only. " +
        "Forecast conditions can change. " +
        "Always check official advisories." +
      "</div>" +

      "</section>";

    container.innerHTML = html;
  }

  function loadFallback() {
    fetch(fallbackUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Fallback HTTP " + response.status
          );
        }

        return response.json();
      })
      .then(function (fallbackData) {
        if (
          fallbackData &&
          fallbackData.fallback_metadata
        ) {
          fallbackData.fallback_metadata.applied_at =
            new Date().toISOString();
        }

        build(fallbackData || {});
      })
      .catch(function () {
        container.innerHTML =
          '<div class="sqr-stale">' +
            "<strong>Unavailable:</strong> " +
            "Weather data currently unavailable. " +
            "Please retry later. Last verified data " +
            "could not be loaded from the backup." +
          "</div>";
      });
  }

  function load(urlToLoad) {
    fetch(urlToLoad)
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "HTTP " + response.status
          );
        }

        return response.json();
      })
      .then(function (data) {
        if (
          data &&
          data.meta &&
          Array.isArray(data.source_data) &&
          Array.isArray(data.siquiride_interpretation)
        ) {
          build(data);
        } else {
          throw new Error(
            "JSON schema/validation failure"
          );
        }
      })
      .catch(function () {
        // Primary weather data failed.
        // Load the last-known-good fallback.
        loadFallback();
      });
  }

  load(url);
})();